// test1253
(1253 && 0);
